var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.382141C4.93466 0.382141 0 5.06272 0 10.8157C0 16.5688 4.93466 21.2493 11 21.2493C17.0653 21.2493 22 16.5688 22 10.8157C22 5.06272 17.0653 0.382141 11 0.382141ZM8.34413 6.24201C9.01418 5.56834 9.95712 5.19765 11 5.19765C12.0429 5.19765 12.9774 5.57085 13.65 6.24803C14.3317 6.93424 14.6633 7.85621 14.585 8.8474C14.4285 10.8157 12.8208 12.4209 11 12.4209C9.17918 12.4209 7.56832 10.8157 7.41495 8.8469C7.33721 7.84769 7.66827 6.92271 8.34413 6.24201ZM11 19.6442C9.75746 19.645 8.5274 19.4091 7.38278 18.9505C6.23815 18.4919 5.20226 17.82 4.33654 16.9746C4.83236 16.3039 5.46412 15.7337 6.1949 15.2972C7.54293 14.4775 9.24899 14.0261 11 14.0261C12.751 14.0261 14.4571 14.4775 15.8035 15.2972C16.5349 15.7335 17.1672 16.3037 17.6635 16.9746C16.7978 17.8201 15.7619 18.4921 14.6173 18.9506C13.4727 19.4092 12.2426 19.6451 11 19.6442Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3a8c0e0522e71614dfcc9b049ab801c5.svg";
export { ForwardRef as ReactComponent };